import React from 'react';
import './FilterPanel.css';

interface FilterField {
  type: 'text' | 'select' | 'date';
  label: string;
  value: string;
  onChange: (value: string) => void;
  options?: { value: string; label: string }[];
  placeholder?: string;
  className?: string;
}

interface FilterPanelProps {
  fields: FilterField[];
  onFilter: () => void;
  onClear: () => void;
  showFilters: boolean;
  onToggleFilters: () => void;
  title?: string;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  fields,
  onFilter,
  onClear,
  showFilters,
  onToggleFilters,
  title = 'Filtros'
}) => {
  const handleFilter = () => {
    onFilter();
    // Ocultar filtros após aplicar
    setTimeout(() => onToggleFilters(), 300);
  };

  const handleClear = () => {
    onClear();
    // Ocultar filtros após limpar
    setTimeout(() => onToggleFilters(), 300);
  };
  return (
    <div className="filter-panel-container">
      <div className="filter-toggle">
        <button 
          className="btn-filter-toggle"
          onClick={onToggleFilters}
          title={showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}
        >
          <i className={`fas ${showFilters ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
          <span>{showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros'}</span>
          <span className="filter-count">
            {fields.filter(f => f.value).length}
          </span>
        </button>
      </div>

      {showFilters && (
        <div className="filter-panel">
          <div className="filter-panel-header">
            <h3>{title}</h3>
          </div>
          
          <div className="filter-panel-content">
            <div className="filter-grid">
              {fields.map((field, index) => (
                <div key={index} className={`filter-field ${field.className || ''}`}>
                  <label className="form-label">{field.label}</label>
                  {field.type === 'text' && (
                    <input
                      type="text"
                      className="form-control"
                      placeholder={field.placeholder}
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                  {field.type === 'select' && (
                    <select
                      className="form-control"
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {field.options?.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  )}
                  {field.type === 'date' && (
                    <input
                      type="date"
                      className="form-control"
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                </div>
              ))}
            </div>
            
            <div className="filter-actions">
              <button className="btn-filter" onClick={handleFilter}>
                <i className="fas fa-filter"></i>
                Aplicar Filtros
              </button>
              <button className="btn-clear" onClick={handleClear}>
                <i className="fas fa-times"></i>
                Limpar Filtros
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;
